<template>
  <div id="excel-presupuestos-rango-fecha">
    <template v-if="boton">
      <custom-button
        label="MODIFICACIONES"
        iconText="fa-file-excel"
        tipo="agregar"
        class="mr-2"
        :loading="estaCargando"
        @click="verRangoFecha = !verRangoFecha">
      </custom-button>
    </template>
    <template v-else>
      <v-list-item
        @click="verRangoFecha = !verRangoFecha"
        link>
          <v-list-item-icon class="mx-2">
            <v-icon> mdi-file-excel </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> Exportar Modificaciones </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
    </template>
    <v-dialog
      v-model="verRangoFecha"
      width="400">
      <v-form ref="from-exportar-rango" v-model="esformularioValido">
        <v-card>
          <v-card-title class="secondary--text">
            Rango de fecha a exportar
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="verRangoFecha = !verRangoFecha">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <custom-date-picker
                v-model="fechaInicial"
                :rules="[mixReglas.requerido]"
                label="Fecha Inicial">
              </custom-date-picker>
              <custom-date-picker
                v-model="fechaFinal"
                :rules="[mixReglas.requerido]"
                label="Fecha Final">
              </custom-date-picker>
            </v-row>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="verRangoFecha = !verRangoFecha"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="generarExcel"
              :disabled="!esformularioValido"
              tipo="formAceptar"
              label="Exportar">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import mixPresupuestos from '@/components/administracion/presupuestos/mixPresupuestos';
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomButton from '@/components/buttons/Button.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 4;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelPresupuestoRangoFecha',
  mixins: [mixPresupuestos, mixGenerarExceles],
  props: {
    // presupuestos: {
    //   type: Array,
    //   required: true,
    // },
    boton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    CustomButton,
    CustomDatePicker,
  },
  data() {
    return {
      esformularioValido: false,
      verRangoFecha: false,
      estaCargando: false,
      fechaInicial: null,
      fechaFinal: null,
      nombreDocumento: 'PRESUPUESTOS RANGO',
      configuracionExcel: {},
      contrato: {
        numero: '',
      },
      filaTitulos: 2,
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      },
      // Datos de los encabezados que apareceran en el excel.
      headersColumnas: [
        // {
        //   value: 'Ejercicio', nombreColumna: 'ejercicio', orden: 1,
        // },
        {
          value: 'Fecha', nombreColumna: 'fecha', orden: 1,
        },
        {
          value: 'Clave', nombreColumna: 'clave', orden: 2,
        },
        {
          value: 'Obra', nombreColumna: 'obra', orden: 3,
        },
        {
          value: 'Tipo', nombreColumna: 'tipo', orden: 4,
        },
        {
          value: 'Importe', nombreColumna: 'importe', orden: 5,
        },
        {
          value: 'No. Referencia', nombreColumna: 'numero', orden: 6,
        },
        {
          value: 'Justificación', nombreColumna: 'justificacion', orden: 7,
        },
      ],
      noData: [{
        fecha: '',
        clave: '',
        obra: '',
        tipo: '',
        importe: '',
        numero: '',
        justificacion: '',
      }],
    };
  },
  methods: {
    generarExcel() {
      this.mixGenerarExcel(this.crearExcelExpedientes);
      this.verRangoFecha = false;
    },
  },
  computed: {
    getPresuspuestos() {
      return this.presupuestos || [];
    },
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    crearDatosDocumento() {
      const inicial = this.$moment(this.fechaInicial).format('DD-MM-YYYY');
      const final = this.$moment(this.fechaFinal).format('DD-MM-YYYY');
      return [
        {
          value: 'PRESUPUESTO RANGO DE FECHA',
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 7,
          },
        },
        {
          value: `${inicial} - ${final}`,
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 2,
            col: 7,
          },
        },
      ];
    },
    getModificaciones() {
      const pptos = JSON.parse(JSON.stringify(this.getPresuspuestos));
      const modificaciones = [];
      pptos.forEach((ppto) => {
        ppto.detalles.forEach((detalle) => {
          detalle.modificaciones.forEach((mod) => {
            const isBetween = this.$moment(mod.fecha)
              .isBetween(this.fechaInicial, this.fechaFinal, undefined, '[]');
            if (isBetween) {
              const datos = {
                fecha: this.$moment(mod.fecha).format('DD-MM-YYYY'),
                clave: detalle.claveObra,
                obra: detalle.obra.meta,
                tipo: mod.tipo,
                importe: {
                  value: mod.importe,
                  estilo: {
                    numberFormat: '$#,##0.00',
                  },
                },
                numero: mod.numero,
                justificacion: mod.justificacion,
              };
              modificaciones.push(datos);
            }
          });
        });
      });
      return modificaciones;
    },
    crearExcelExpedientes() {
      // const expedientesExcel = this.getExpedientesParaExcel;
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      // Se agregan totales para cantidad e importe a nombres de columnas.
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getModificaciones.length > 0 ? this.getModificaciones : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            // logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },
};
</script>

<style>
</style>
